package com.gsb.vyapar.bhagya.presentation.splash.event

import androidx.compose.ui.platform.UriHandler

sealed class SplashUiEvents {
    data class GetSplashUiData(val uriHandler: UriHandler) : SplashUiEvents()
}